/* eslint-disable import/prefer-default-export */

export const LOAD_BULK_EDIT_ITEMS = 'LOAD_BULK_EDIT_ITEMS';
